import { stopServeUseCase } from "./stopServe";

export const serveProjectUseCase = async ({
  getFreshToken,
  getEndpointUrl,
  repoName,
  browserTab,
  setBrowserTab,
}) => {
  try {
    await stopServeUseCase({
      getFreshToken,
      getEndpointUrl,
      browserTab,
      setBrowserTab,
    });
    console.log("Successfully stopped existing serve process.");
  } catch (error) {
    console.warn(
      "No existing serve process to stop or encountered an error:",
      error.message
    );
  }

  const freshToken = await getFreshToken();
  const response = await fetch(getEndpointUrl() + `/serve?repo=${repoName}`, {
    headers: {
      Authorization: `Bearer ${freshToken}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Error serving the React app for ${repoName}.`);
  }

  console.log(`React app for ${repoName} is being served.`);

  if (browserTab && !browserTab.closed) {
    browserTab.close();
    console.log("Closed existing browser tab.");
  }

  const newTab = window.open("http://localhost:4000", "_blank");
  setBrowserTab(newTab);
  console.log("Opened new browser tab for served project.");

  return "App is being served successfully";
};
